import { Component } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Button, FormControl, InputLabel } from "@mui/material";
import Icon from "@mui/material/Icon/Icon";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { NO_VALUE } from "../../../constants";
import CustomizedSelect from "../../Input/CustomizedSelect";

class InterventionSelectField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	remove(arr) {
		var what,
			a = arguments,
			L = a.length,
			ax;
		while (L > 1 && arr.length) {
			what = a[--L];
			while ((ax = arr.indexOf(what)) !== -1) {
				arr.splice(ax, 1);
			}
		}
		return arr;
	}

	handleChange(e) {
		let fieldValue = this.props.value;
		if (this.props.multiple) {
			let newArray = this.remove(e.target.value, NO_VALUE);
			fieldValue.value_choice_ids = newArray;
		} else {
			if (e.target.value === NO_VALUE) fieldValue.value_choice_id = "";
			else fieldValue.value_choice_id = e.target.value;
		}

		this.props.fieldValueChange(fieldValue);
	}

	openSelect() {
		this.setState({ open: true });
	}

	closeSelect() {
		this.setState({ open: false });
	}

	render() {
		console.perfLog(getCurrentFunctionName());

		let sortedChoices = this.props.model.choice_ids.sort((c1, c2) => {
			if (c1.sequence < c2.sequence) return -1;
			else if (c1.sequence > c2.sequence) return 1;
			else return 0;
		});

		let rows = [
			<MenuItem key={NO_VALUE} value={NO_VALUE}>
				{this.props.multiple ? (
					<Button
						className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding"
						onClick={this.closeSelect.bind(this)}
					>
						<Icon className="green-icon">check</Icon>
					</Button>
				) : (
					""
				)}
			</MenuItem>,
		];

		for (let i = 0; i < sortedChoices.length; i++) {
			let currentRow = sortedChoices[i];

			rows.push(
				<MenuItem key={i} value={currentRow.id}>
					{currentRow.name}
				</MenuItem>
			);
		}

		let value = this.props.value.value_choice_ids;

		if (!this.props.multiple) {
			if (!this.props.value.value_choice_id) value = "";
			else value = this.props.value.value_choice_id;
		}

		return (
			<div className=" col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding control-margin-top">
				<FormControl className="row">
					<InputLabel id={"intervention-select-field-label-" + this.props.inputProperties.id}>{this.props.model.name}</InputLabel>
					<CustomizedSelect
						labelId={"intervention-select-field-label-" + this.props.inputProperties.id}
						id={"intervention-select-field-" + this.props.inputProperties.id}
						{...this.props.inputProperties}
						label={this.props.model.name}
						placeholder={this.props.model.name}
						multiple={this.props.multiple}
						className={this.props.inputProperties.className + " full_size control-margin-top"}
						onChange={this.handleChange.bind(this)}
						onOpen={this.openSelect.bind(this)}
						onClose={this.closeSelect.bind(this)}
						open={this.state.open}
						value={value}
					>
						{rows}
					</CustomizedSelect>
				</FormControl>
			</div>
		);
	}
}

export default (InterventionSelectField);
